import React, { useEffect, useState, useRef } from 'react';
import {
  Modal,
  Box,
  Typography,
  TextField,
  Button,
  Stack,
  CircularProgress,
  InputAdornment,
  IconButton,
  Snackbar,
  Alert,
} from '@mui/material';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import './styles.css';
import fetchAPI from '../../utils/fetchAPI';
import { Visibility, VisibilityOff } from '@mui/icons-material';
const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 400,
  bgcolor: 'background.paper',
  border: '2px solid #000',
  boxShadow: 24,
  p: 4,
};

export const RecuperarPasswd = ({ visible, onClose }) => {
  const [open, setOpen] = useState(visible);
  const [userInput, setUserIput] = useState('');
  const [birthDate, setBirthDate] = useState(null);
  const [error, setError] = useState('');
  const [validateQuestion, setValidateQuestion] = useState(true);
  const [questionApi, setQuestionApi] = useState(null);
  const [answerApi, setAnswerApi] = useState(null);
  const [loading, setLoading] = useState(false);
  const [activeModalRecuperatePassword, setActiveModalRecuperatePassword] = useState(false);
  const [newPassword, setNewPassword] = useState(null);
  const [confirmPassword, setConfirmPassword] = useState('');
  const [showPassword1, setShowPassword1] = useState(false);
  const [showPassword2, setShowPassword2] = useState(false);
  const [captchaToken, setCaptchaToken] = useState(null);
  const handleTogglePassword1 = () => setShowPassword1(!showPassword1);
  const handleTogglePassword2 = () => setShowPassword2(!showPassword2);
  const captchaRef = useRef(null);

  const resetCaptcha = () => {
    setCaptchaToken(null);
    if (window.turnstile && captchaRef.current) {
      window.turnstile.reset(captchaRef.current);
    }
  };

  useEffect(() => {
    setOpen(visible);
  }, [visible]);

  useEffect(() => {
    const interval = setInterval(() => {
      if (window.turnstile && captchaRef.current) {
        window.turnstile.render(captchaRef.current, {
          sitekey: window.REACT_APP_TURNSTILE_SITE_KEY,
          callback: (token) => setCaptchaToken(token),
          'expired-callback': () => {
            setCaptchaToken(null);
            setError('El captcha expiró, verifica nuevamente');
          },

          'error-callback': () => {
            setCaptchaToken(null);
            setError('Error en el captcha, intenta de nuevo');
          },
        });
        clearInterval(interval);
      }
    }, 300);

    return () => clearInterval(interval);
  }, []);

  const handleClose = () => {
    setOpen(false);
    onClose();
    setBirthDate(null);
    setError('');
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    if (!birthDate || !userInput) {
      setError('Todos los campos son requeridos');
      resetCaptcha();
      setLoading(false);
      return;
    }

    if (!captchaToken) {
      setError('Por favor completa el captcha');
      setLoading(false);
      return;
    }

    const service = 'v1/MX/passwd/get-question';
    console.log('TOKEN:', captchaToken);
    fetchAPI({
      service: service,
      protocol: 'POST',
      params: {
        customer_no: userInput,
        birthday_at: birthDate,
        captchaToken: captchaToken,
      },
      callbackThen: (Respond) => {
        if (Respond === 500) {
          setError('El usuario o fecha de nacimiento es incorrecto');
          resetCaptcha();
          setLoading(false);
          return;
        }
        setValidateQuestion(false);
        setQuestionApi(Respond?.question);
        setLoading(false);
      },
      callbackCatch: () => {
        setLoading(false);
        setError('Error al validar usuario');
        resetCaptcha();
      },
    });
  };

  const handleSubmitAnswer = (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    if (!answerApi) {
      setLoading(false);
      setError('el campo requerido');
      resetCaptcha();
      return;
    }
    const service = 'v1/MX/passwd/validate-response';
    fetchAPI({
      service: service,
      protocol: 'POST',
      params: {
        customer_no: userInput,
        response: answerApi,
      },
      callbackThen: (Respond) => {
        if (Respond.validate) {
          setQuestionApi(false);
          setActiveModalRecuperatePassword(true);
        } else {
          setError('Respuesta incorrecta');
        }
        setLoading(false);
      },
      callbackCatch: () => {},
    });
  };

  const handleSubmitNewPassword = (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    const passwordRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{12}$/;
    if (!passwordRegex.test(newPassword)) {
      setError(
        'La contraseña debe tener 12 caracteres, incluyendo al menos una mayúscula, una minúscula, un número y un carácter especial.'
      );
      resetCaptcha();
      setLoading(false);
      return;
    }
    if (newPassword !== confirmPassword) {
      setError('Las contraseñas no coinciden');
      setLoading(false);
      resetCaptcha();
      return;
    }
    if (!newPassword) {
      setError('el campo requerido');
      setLoading(false);
      return;
    }
    const service = 'v1/MX/passwd/update-password';
    fetchAPI({
      service: service,
      protocol: 'PUT',
      params: {
        customer_no: userInput,
        newPassword: newPassword,
      },
      callbackThen: (Respond) => {
        if (Respond?.validate) {
          setActiveModalRecuperatePassword(false);
          onClose(true);
        }
        setCaptchaToken(null);
        resetCaptcha();
        setLoading(false);
        setActiveModalRecuperatePassword(false);
      },
      callbackCatch: () => {
        setActiveModalRecuperatePassword(false);
        setLoading(false);
        resetCaptcha();
      },
    });
  };

  return (
    <div>
      <Modal open={open} onClose={handleClose} aria-labelledby="modal-title" aria-describedby="modal-description">
        <Box sx={style}>
          <Typography id="modal-title" variant="h6" component="h2" gutterBottom>
            Recuperar contraseña
          </Typography>
          {validateQuestion && (
            <form onSubmit={handleSubmit}>
              <Stack spacing={3}>
                <TextField
                  fullWidth
                  type="number"
                  value={userInput}
                  onChange={(e) => setUserIput(e.target.value)}
                  label="Usuario"
                  variant="outlined"
                />

                <Box>
                  <Typography variant="body1" gutterBottom>
                    Fecha de nacimiento
                  </Typography>
                  <DatePicker
                    selected={birthDate}
                    onChange={(date) => setBirthDate(date)}
                    dateFormat="dd/MM/yyyy"
                    placeholderText="Selecciona tu fecha de nacimiento"
                    className="custom-datepicker"
                    maxDate={new Date()}
                  />
                </Box>

                {error && (
                  <Typography color="error" variant="body2">
                    {error}
                  </Typography>
                )}

                <div ref={captchaRef}></div>

                <Button
                  variant="contained"
                  color="primary"
                  type="submit"
                  disabled={loading}
                  sx={{
                    position: 'relative',
                    width: 150,
                    height: 40,
                  }}
                >
                  {loading ? (
                    <CircularProgress
                      size={24}
                      sx={{
                        color: 'white',
                        position: 'absolute',
                      }}
                    />
                  ) : (
                    'Enviar'
                  )}
                </Button>
              </Stack>
            </form>
          )}
          {questionApi && (
            <form onSubmit={handleSubmitAnswer}>
              <Stack spacing={3}>
                <TextField
                  fullWidth
                  type="text"
                  value={answerApi}
                  onChange={(e) => setAnswerApi(e.target.value)}
                  label={questionApi}
                  variant="outlined"
                />

                {error && (
                  <Typography color="error" variant="body2">
                    {error}
                  </Typography>
                )}
                <Button
                  variant="contained"
                  color="primary"
                  type="submit"
                  disabled={loading}
                  sx={{
                    position: 'relative',
                    width: 150,
                    height: 40,
                  }}
                >
                  {loading ? (
                    <CircularProgress
                      size={24}
                      sx={{
                        color: 'white',
                        position: 'absolute',
                      }}
                    />
                  ) : (
                    'Enviar'
                  )}
                </Button>
              </Stack>
            </form>
          )}
          {activeModalRecuperatePassword && (
            <form onSubmit={handleSubmitNewPassword}>
              <Stack spacing={3}>
                <TextField
                  fullWidth
                  type={showPassword1 ? 'text' : 'password'}
                  value={newPassword}
                  onChange={(e) => setNewPassword(e.target.value)}
                  label={'Nueva contraseña'}
                  variant="outlined"
                  inputProps={{
                    maxLength: 12,
                  }}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        <IconButton onClick={handleTogglePassword1} edge="end">
                          {showPassword1 ? <VisibilityOff fontSize="large" /> : <Visibility fontSize="large" />}
                        </IconButton>
                      </InputAdornment>
                    ),
                  }}
                />
                <TextField
                  fullWidth
                  type={showPassword2 ? 'text' : 'password'}
                  value={confirmPassword}
                  onChange={(e) => setConfirmPassword(e.target.value)}
                  label={'Confirmar contraseña'}
                  variant="outlined"
                  inputProps={{
                    maxLength: 12,
                  }}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        <IconButton onClick={handleTogglePassword2} edge="end">
                          {showPassword2 ? <VisibilityOff fontSize="large" /> : <Visibility fontSize="large" />}
                        </IconButton>
                      </InputAdornment>
                    ),
                  }}
                />

                {error && (
                  <Typography color="error" variant="body2">
                    {error}
                  </Typography>
                )}

                <Button
                  variant="contained"
                  color="primary"
                  type="submit"
                  disabled={loading}
                  sx={{
                    position: 'relative',
                    width: 150,
                    height: 40,
                  }}
                >
                  {loading ? (
                    <CircularProgress
                      size={24}
                      sx={{
                        color: 'white',
                        position: 'absolute',
                      }}
                    />
                  ) : (
                    'Enviar'
                  )}
                </Button>
              </Stack>
            </form>
          )}
        </Box>
      </Modal>
    </div>
  );
};
